import { Progress } from '@/components/ui/progress'
import { cn } from '@/lib/utils'

interface DealProgressProps {
  numerator?: number | null;
  denominator?: number | null;
  label?: string;
  variant?: 'default' | 'remaining';
  labelPosition?: 'above' | 'below';
  labelClassName?: string;
  className?: string;
}

type ProgressStatus = 'healthy' | 'warning' | 'alert';

const STATUS_COLORS = {
  healthy: 'bg-green-100 [&>div]:bg-green-500',
  warning: 'bg-yellow-100 [&>div]:bg-yellow-500',
  alert: 'bg-red-100 [&>div]:bg-red-500',
} as const;

export function DealProgress({
  numerator,
  denominator,
  label = "taken",
  variant = "default",
  labelPosition = "below",
  labelClassName = "text-xs text-muted-foreground mt-1",
  className
}: DealProgressProps) {
  // Return null if either value is missing or zero
  if (numerator === null || numerator === undefined || !denominator){
    return null;
  }

  const progress = (numerator / denominator) * 100;

  const getStatus = (): ProgressStatus => {
    if (variant === "remaining") {
      if (numerator <= 3) return 'alert';
      if (numerator < 6) return 'warning';
      return 'healthy';
    }
    // Default variant (used for renewals)
    if (numerator >= denominator) return 'alert';
    if (denominator - numerator === 1) return 'warning';
    return 'healthy';
  }

  const progressBar = (
    <Progress
      value={progress}
      className={cn(
        "h-2",
        "w-24",
        STATUS_COLORS[getStatus()],
        className
      )}
    />
  );

  const labelElement = (
    <div className={labelClassName}>
      {numerator} / {denominator} {label}
    </div>
  );

  return (
    <>
      {labelPosition === "above" && labelElement}
      {progressBar}
      {labelPosition === "below" && labelElement}
    </>
  );
}
/*  */
